import script from "./CompanyAvatar.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanyAvatar.vue?vue&type=script&lang=ts&setup=true"

import "./CompanyAvatar.vue?vue&type=style&index=0&id=d54d152c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d54d152c"]])

export default __exports__